export default __webpack_public_path__ + "static/bottomSwirlImage2-88b1dc69c1cf5dd1436498992cf74d5e.svg";